import { styled } from "sharedUI/styles";

export const AppInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const AppTitle = styled.div`
    font-weight: bold;
    font-size: 34px;
    line-height: 37px;
    text-align: center;

    margin-top: 6px;

    color: ${p => p.theme.fgColorDark};
`;
